import { type AxiosInstance } from "axios";
import { type PictureResponse } from "@/types/acquirebook";
import { type PropertyCodeNewAcquireRequest } from "@/features/propertyCodeAcquisition/utils/newAcquireRequest";
import { type PropertyCodeReuseAcquireRequest } from "@/features/propertyCodeAcquisition/utils/reuseAcquireRequest";

// 取得実行（新規/リユース）の POST 呼び出し層。
// hook（usePropertyCodeAcquireBookForm）は送信先エンドポイントの確定・エラー分類・成功後処理に専念し、
// HTTP 呼び出し自体は本関数へ集約する。エラーはそのまま throw し、分類は呼び出し側で行う。

/** 取得実行 payload（新規／リユースのいずれか・地番を含まない＝物件コードでリクエストする）。 */
export type AcquireRequestPayload =
  | PropertyCodeNewAcquireRequest
  | PropertyCodeReuseAcquireRequest;

/**
 * 取得実行エンドポイントへ payload を POST する。成功レスポンスは { status: "OK" }。
 * @param apiClient JWT 認証付き apiClient
 * @param url 送信先エンドポイント（物件コード配下）
 * @param payload 取得実行 payload（新規／リユース）
 */
export const postAcquireRequest = async (
  apiClient: AxiosInstance,
  url: string,
  payload: AcquireRequestPayload
): Promise<PictureResponse> => {
  const { data } = await apiClient.post<PictureResponse>(url, payload);
  return data;
};
